import { JobShareDetails } from "../../types/jobShareDetails";
import { JobShareResponse } from "../controllers/jobs";

export const convertShareJobResponse = (
    response: JobShareResponse
): JobShareDetails => {
    const jobShareDetails = new JobShareDetails();
    jobShareDetails.emailUrl = response.emailUrl;
    jobShareDetails.shortenedUrl = response.shortenedUrl;
    jobShareDetails.jobName = response.jobName;
    jobShareDetails.facebookUrl = response.facebookUrl;
    jobShareDetails.twitterUrl = response.twitterUrl;
    jobShareDetails.linkedInUrl = response.linkedInUrl;

    return jobShareDetails;
};
